import { fromPromise } from 'xstate';

import { inferDecisionMakers } from '#src/app/pages/startAPetitionV2/shared/api';

import type { OperationDeps } from '../types';

import type { Input, Output } from './types';

/**
 * The decision-maker inference operation: one `inferDecisionMakers` call. The variant only starts it
 * for a draft that qualifies.
 */
export const createLogic = ({ utilityContext, track }: OperationDeps) =>
	fromPromise<Output, Input>(async ({ input }) => inferDecisionMakers(input, { utilityContext, track }));
